
                    module.exports = {"name":"search","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M10 17a7 7 0 100-14 7 7 0 000 14zM15 15l6 6\" _stroke=\"#506179\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>"}}
            